import { Component, OnDestroy, OnInit } from '@angular/core';

import { AbstractDialogComponent } from '@Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '@Core/Dialogs/services/dialog.service';

import { ButtonTypesEnum } from '@Common/Forms/enums/button-types.enum';
import { messageSeverityEnum } from '@Common/Misc/enums/message-severity.enum';
import { BriefingConfigService } from '@Common/MonitorShared/services/briefing-config.service';
import { Subscription, filter } from 'rxjs';

@Component({
    selector: 'agpr-alert-limit-reached',
    templateUrl: './alert-limit-reached.component.html',
    styleUrls: ['./alert-limit-reached.component.scss'],
    standalone: false
})

export class AlertLimitReachedDialogComponent extends AbstractDialogComponent implements OnInit, OnDestroy {
    readonly buttonTypes = ButtonTypesEnum;
    readonly messageSeverities = messageSeverityEnum;

    alertLimit: number;
    private subscriptions: Subscription[] = [];

    constructor(
        public coreDialogService: CoreDialogService,
        public briefingConfigService: BriefingConfigService
    ) {
        super(coreDialogService, 'AlertLimitReached');
    }

    ngOnInit() {
        this.subscriptions.push(
            this.briefingConfigService.getAlertLimit().pipe(filter(x => !!x)).subscribe(
                limit => {
                    this.alertLimit = limit;
                }
            )
        );
    }

    cancel() {
        this.closeDialog(false);
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((sub) => sub.unsubscribe());
    }
}
